import { Typography } from '@mui/material';
import { useStyles } from './SidebarHeader.styles';
import React, { FC } from 'react';

interface MenuListProps {
  value?: string;
}

export const SidebarHeader: FC<MenuListProps> = ({ value }) => {
  const { classes } = useStyles();

  if (!value) {
    return null;
  }

  return (
    <Typography className={classes.root} variant="body1">
      {value}
    </Typography>
  );
};
